@if (templateUtils$ | async; as utils) {
  <header class="header">
    @if (currentPath$ | async; as currentPath) {
      @if ((currentPath.isMainPath || !utils.isMobile) && !showBack) {
        <a
          class="header__logo"
          [routerLink]="'explore' | routeTranslate">
          <img
            loading="eager"
            fetchpriority="high"
            src="https://media.sharry.land/app/images/logo-sharry.svg"
            alt="logo"
            width="32"
            height="32" />
          <p>SHARRY<span>LAND</span></p>
        </a>
      } @else {
        <div class="header__logo">
          <button
            mat-icon-button
            class="sharry-small is-mobile"
            (click)="onBack()">
            <sharry-icon registryName="caret-left"></sharry-icon>
          </button>
        </div>
      }
    }
    <div
      class="is-not-mobile header__expanded-title"
      [ngClass]="{ hidden: !complete }">
      <p>{{ 'shop.header.head' | i18next }}</p>
    </div>
    <div
      class="header__search is-not-mobile"
      [ngClass]="{ hidden: complete }">
      <div
        class="header__search__input"
        role="button"
        tabindex="-1"
        [searchTriggerFor]="search"
        [userSearchKind]="userSearchKind.FindSearch">
        <p>
          @if (icons[userSearchKind.FindSearch]) {
            <sharry-icon
              svgClass="header__search__icon"
              [name]="icons[userSearchKind.FindSearch]"></sharry-icon>
          }
          {{ 'shop.header.find-label' | i18next }}
        </p>
        @if (searchValues?.find) {
          <p
            sharryEllipsisTooltip="1"
            class="bold">
            {{ searchValues.find }}
          </p>
        } @else {
          <small sharryEllipsisTooltip="1">{{ 'shop.header.find' | i18next }}</small>
        }
      </div>
      <div
        class="header__search__input"
        role="button"
        tabindex="-1"
        [searchTriggerFor]="search"
        [userSearchKind]="userSearchKind.WhereSearch">
        <p>
          @if (icons[userSearchKind.WhereSearch]) {
            <sharry-icon
              svgClass="header__search__icon"
              [name]="icons[userSearchKind.WhereSearch]"></sharry-icon>
          }
          {{ 'shop.header.where-label' | i18next }}
        </p>
        @if (searchValues?.where) {
          <p
            sharryEllipsisTooltip="1"
            class="bold">
            {{ searchValues.where }}
          </p>
        } @else {
          <small sharryEllipsisTooltip="1">{{ 'shop.header.where' | i18next }}</small>
        }
      </div>
      <div
        class="header__search__input"
        role="button"
        tabindex="-1"
        [searchTriggerFor]="search"
        [userSearchKind]="userSearchKind.WhenSearch">
        <p>
          @if (icons[userSearchKind.WhenSearch]) {
            <sharry-icon
              svgClass="header__search__icon"
              [name]="icons[userSearchKind.WhenSearch]"></sharry-icon>
          }
          {{ 'shop.header.when-label' | i18next }}
        </p>
        @if (searchValues?.when) {
          <p
            sharryEllipsisTooltip="1"
            class="bold">
            {{ searchValues.when }}
          </p>
        } @else {
          <small sharryEllipsisTooltip="1">{{ 'shop.header.when' | i18next }}</small>
        }
      </div>
      <button
        mat-icon-button
        color="primary"
        class="header__search__links__search sharry-medium sharry-inverted"
        [searchTriggerFor]="search">
        <sharry-icon
          name="magnifying-glass"
          svgClass="svg-icon"></sharry-icon>
      </button>
    </div>
    <div class="header__links">
      @if (shouldHavelanguageChange()) {
        <button
          color="secondary"
          class="sharry-small is-mobile"
          mat-icon-button
          (click)="onLanguageChange()">
          <sharry-icon name="globe"></sharry-icon>
        </button>
      }
      @if (userService.user$ | async; as user) {
        <a
          color="secondary"
          class="sharry-small is-mobile"
          mat-icon-button
          [routerLink]="'messages' | routeTranslate">
          <sharry-icon name="chat-circle-text"></sharry-icon>
          @if (messagesCount$ | async; as messagesCount) {
            <span class="not-read-pin">{{ messagesCount < 10 ? messagesCount : '9+' }}</span>
          }
        </a>
        <a
          color="secondary"
          class="sharry-small is-mobile"
          mat-icon-button
          [routerLink]="'notifications' | routeTranslate">
          <sharry-icon name="bell"></sharry-icon>
          @if (notificationsCount$ | async; as notificationsCount) {
            <span class="not-read-pin">{{ notificationsCount < 10 ? notificationsCount : '9+' }}</span>
          }
        </a>
      }
      @if (shouldHavelanguageChange()) {
        <button
          color="secondary"
          class="sharry-small is-not-mobile"
          mat-icon-button
          (click)="onLanguageChange()">
          <sharry-icon name="globe"></sharry-icon>
        </button>
      }
      @if (!isBehalfCart) {
        <a
          color="secondary"
          class="sharry-small"
          mat-icon-button
          [routerLink]="'cart' | routeTranslate">
          <sharry-icon name="carrello"></sharry-icon>
          @if (cartItemsCount$ | async; as cartItemsCount) {
            <span class="not-read-pin">{{ cartItemsCount < 10 ? cartItemsCount : '9+' }}</span>
          }
        </a>
      }
      <sharry-header-menu (expandedMenu)="onMenuExpanded($event)"></sharry-header-menu>
    </div>
  </header>

  <sharry-header-search
    #search
    [menuExpanded]="menuExpanded"
    (isComplete)="changeComplete($event)"
    (clearWhere)="clearWhere()"
    (clearWhen)="clearWhen()"
    (clearFind)="clearFind()"
    (clearFilters)="clearPlaceholders()"></sharry-header-search>
}
